import { Route, Routes } from "react-router-dom"

import { NotFoundView } from "errors"
import { OnboardContainer } from "onboard"

const RoutesContainer: React.FC = () => (
  <Routes>
    <Route path="/welcome/:practiceIdentifier/patient/:personIdentifier" element={<OnboardContainer />} />
    <Route path="/welcome/:practiceIdentifier/patient" element={<OnboardContainer />} />
    <Route path="*" element={<NotFoundView />} />
  </Routes>
)

export { RoutesContainer }
